import { ca } from '@cian/analytics';
import { EType as EInteriorDecorationType } from '../../../repositories/newbuilding-card/entities/decoration/InteriorDecorationSchema';
import { getNewbuildingProduct } from '../../../utils/analytics';

export const trackClickInteriorDecoration = (id: number, type: EInteriorDecorationType) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Finishing',
    action: 'click_sopr',
    label: 'jk',
    products: [
      getNewbuildingProduct({
        newbuildingId: id,
        extra: {
          finishing_type: type,
        },
      }),
    ],
  });
};
